import React, { useState } from "react";
import "./Pricing.css";
import CTAButton from "../CTAButton/CTAButton";
import aiFallback from "../../assets/ai-section-fallback.png";
import pricebanner from "../../assets/new/Affordable Email Marketing Pricing Plans That Grow with Your Business mailsnappy.png";
import ManagedFaqSection, { pageFaqDefaults } from "../ManagedFaqSection/ManagedFaqSection";


const Pricing = () => {
  const packages = [
    { price_usd: 10, subscribers: 500, emails: 10000 },
    { price_usd: 13.5, subscribers: 1000, emails: 10000 },
    { price_usd: 20, subscribers: 2500, emails: 25000 },
    { price_usd: 31.5, subscribers: 5000, emails: 50000 },
    { price_usd: 38, subscribers: 7500, emails: 75000 },
    { price_usd: 44.5, subscribers: 10000, emails: 100000 },
    { price_usd: 60, subscribers: 15000, emails: 150000 },
    { price_usd: 78, subscribers: 20000, emails: 200000 },
    { price_usd: 94.5, subscribers: 25000, emails: 250000 },
    { price_usd: 112, subscribers: 30000, emails: 300000 },
    { price_usd: 128, subscribers: 35000, emails: 350000 },
    { price_usd: 145, subscribers: 40000, emails: 400000 },
    { price_usd: 162, subscribers: 45000, emails: 450000 },
    { price_usd: 178, subscribers: 50000, emails: 500000 },
    { price_usd: 195, subscribers: 55000, emails: 550000 },
    { price_usd: 212, subscribers: 60000, emails: 600000 },
    { price_usd: 228, subscribers: 65000, emails: 650000 },
    { price_usd: 245, subscribers: 70000, emails: 700000 },
    { price_usd: 262, subscribers: 75000, emails: 750000 },
    { price_usd: 280, subscribers: 80000, emails: 800000 },
    { price_usd: 298, subscribers: 85000, emails: 850000 },
    { price_usd: 316, subscribers: 90000, emails: 900000 },
    { price_usd: 334, subscribers: 95000, emails: 950000 },
    { price_usd: 352, subscribers: 100000, emails: 1000000 },
    { price_usd: 390, subscribers: 120000, emails: 1200000 },
    { price_usd: 430, subscribers: 140000, emails: 1400000 },
    { price_usd: 470, subscribers: 160000, emails: 1600000 },
    { price_usd: 510, subscribers: 180000, emails: 1800000 },
    { price_usd: 550, subscribers: 200000, emails: 2000000 },
    { price_usd: 600, subscribers: 225000, emails: 2250000 },
    { price_usd: 650, subscribers: 250000, emails: 2500000 },
    { price_usd: 700, subscribers: 275000, emails: 2750000 },
    { price_usd: 750, subscribers: 300000, emails: 3000000 },
    { price_usd: 820, subscribers: 325000, emails: 3250000 },
    { price_usd: 890, subscribers: 350000, emails: 3500000 },
    { price_usd: 960, subscribers: 375000, emails: 3750000 },
    { price_usd: 1030, subscribers: 400000, emails: 4000000 },
    { price_usd: 1100, subscribers: 425000, emails: 4250000 },
    { price_usd: 1180, subscribers: 450000, emails: 4500000 },
    { price_usd: 1260, subscribers: 475000, emails: 4750000 },
    { price_usd: 1478, subscribers: 500000, emails: 5000000 },
  ];

  const [selected, setSelected] = useState(0);

  return (
    <div className="pricing-page">
      {/* HERO SECTION */}
      <section className="pricing-hero">
        <div className="pricing-hero-copy">
          <h1>Affordable Email Marketing Pricing Plans That Grow with Your Business</h1>
          <p>Choose flexible email marketing pricing plans designed to support businesses at every stage of growth. Whether you are just getting started or managing large email campaigns, MailSnappy offers transparent pricing with powerful features, including email marketing automation, responsive email templates, subscriber management, campaign analytics, and AI powered tools. Scale your email marketing platform with confidence and pay only for the features your business needs, without hidden fees or unnecessary complexity</p>
        </div>
        <div className="pricing-hero-visual">
          <img src={pricebanner} alt="Pricing plan dashboard preview" />
        </div>
      </section>

      {/* PRICING TABLE */}
      <section className="pricing-container">
        <div className="pricing-card pricing-card-free">
          <h2>Free Plan</h2>
          <div className="price">$0.00</div>
          <p className="per-month">per month</p>

          <p className="pricing-subscriber-limit">Subscribers: Unlimited</p>
          <p className="pricing-email-limit">50 emails/month</p>

          <ul>
            <li>Start sending email campaigns for free</li>
            <li>Access responsive email templates</li>
            <li>Use signup forms and landing pages</li>
            <li>Try the email editor</li>
            <li>No credit card required</li>
          </ul>
        </div>

        <div className="pricing-card">
          <h2>Pro Plan</h2>
          <div className="price">${packages[selected].price_usd.toFixed(2)}</div>
          <p className="per-month">per month</p>

          <div className="slider">
            <label>Subscribers: Unlimited</label>
            <input
              type="range"
              min="0"
              max={packages.length - 1}
              value={selected}
              onChange={(e) => setSelected(Number(e.target.value))}
            />
          </div>

          <p className="pricing-email-limit">{packages[selected].emails.toLocaleString()} emails/month</p>

          <ul>
            <li>Full control over your email design</li>
            <li>Reports available forever</li>
            <li>Unlimited landing pages and forms</li>
            <li>Add unlimited users</li>
            <li>Cancel any time</li>
          </ul>
        </div>
      </section>

      {/* INFO BOXES */}
      <section className="pricing-info">
        <div className="info-box">
          <h3>Charity or nonprofit?</h3>
          <p>
            We support nonprofits with a <strong>20% lifetime discount</strong> on all plans.
          </p>
        </div>
        <div className="info-box">
          <h3>Custom plans</h3>
          <p>For more than 500,000 subscribers, contact us for a quote.</p>
        </div>
        <div className="info-box">
          <h3>Automatic upgrades</h3>
          <p>Your plan adjusts automatically as your mailing list grows.</p>
        </div>
      </section>

      <ManagedFaqSection
        pageKey="pricing"
        heading="Pricing FAQs"
        fallback={pageFaqDefaults.pricing}
      />

      {/* CTA */}
      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Pricing;
